import { render, staticRenderFns } from "./FareGroupDetails.vue?vue&type=template&id=4a64c4e6&"
import script from "./FareGroupDetails.vue?vue&type=script&lang=js&"
export * from "./FareGroupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports